import { render } from "./Ad.vue?vue&type=template&id=1ecf48e1&scoped=true"
import script from "./Ad.vue?vue&type=script&lang=js"
export * from "./Ad.vue?vue&type=script&lang=js"

import "./Ad.vue?vue&type=style&index=0&id=1ecf48e1&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecf48e1"]])

export default __exports__